import { CanMarshal } from "src/app/shared-module/models/canMarshal.model"

export class LocaleSettings extends CanMarshal<LocaleSettings> {
	public language: string
	public tempUnits: "c" | "f"
	public depthUnits: "m" | "f"
}